module.exports = __webpack_public_path__ + "static/img/10.079461f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shlzy/10.png
// module id = NO5U
// module chunks = 0